import { extend, localize } from 'vee-validate';
import {
  required, min, max, min_value as minValue,
} from 'vee-validate/dist/rules';
import {
  isUploading,
  minLength,
  maxLength,
  decimal,
  iframe,
  soundcloudIframe,
  nullableEmail,
  nullableTwitter,
  nullableFacebook,
  nullableInstagram,
  nullableYoutube,
  nullableTiktok,
  waitUpload,
  url,
  absoluteUrl,
  relativeUrl,
  hasCoverImage,
  validCropSettings,
  rel,
  validAnnouncementNumber,
  hexColor,
} from './validators';
import { errorMessages } from './errorMessages';

extend('required', { ...required });
extend('minLength', { ...minLength });
extend('maxLength', { ...maxLength });
extend('max', { ...max });
extend('min', { ...min });
extend('decimal', { ...decimal });
extend('iframe', { ...iframe });
extend('soundcloudIframe', { ...soundcloudIframe });
extend('nullableEmail', { ...nullableEmail });
extend('nullableTwitter', { ...nullableTwitter });
extend('nullableFacebook', { ...nullableFacebook });
extend('nullableInstagram', { ...nullableInstagram });
extend('nullableYoutube', { ...nullableYoutube });
extend('nullableTiktok', { ...nullableTiktok });
extend('waitUpload', { ...waitUpload });
extend('url', { ...url });
extend('rel', { ...rel });
extend('absoluteUrl', { ...absoluteUrl });
extend('relativeUrl', { ...relativeUrl });
extend('minValue', { ...minValue });
extend('hasCoverImage', { ...hasCoverImage });
extend(('isUploading'), { ...isUploading });
extend(('validCropSettings'), { ...validCropSettings });
extend(('announcementNumber'), { ...validAnnouncementNumber });
extend(('hexColor'), { ...hexColor });

localize({
  en: {
    names: {
      contentType: 'Content Type',
      category: 'Category',
      source: 'Source',
      author: 'Author',
      cartoonists: 'Cartoonist',
      program: 'Program',
      magazineQuote: 'Issue Number',
      signature: 'Signature',
      socialMedia: 'Social Media',
      title: 'Title',
      spot: 'Spot',
      tag: 'Tag',
      photoGallery: 'Photo Gallery',
      infographicGallery: 'Infographic Gallery',
      coverImage: 'Cover Image',
      coverImageDescription: 'Cover Image Description',
      coverVideo: 'Cover Video',
      startDate: 'Start Date',
      endDate: 'End Date',
      publishDate: 'Publish Date',
      expirationDate: 'Expiration Date',
      headlineTag: 'Headline Tag',
      platform: 'Platform',
      headlineOrder: 'Headline Order',
      order: 'Order',
      site: 'Site',
      role: 'Role',
      permission: 'Permission',
      externalLink: 'External Link',
      embedCode: 'Embed Code',
      mobileApplication: 'Mobile Application',
      rows: 'Rows',
      columns: 'Columns',
      subject: 'Subject Title',
      book: 'Book',
      mainSubject: 'Main Subject Title',
      menuItemType: 'Item Type',
      brandLogo: 'Brand Logo',
      brandLogoDark: 'Brand Logo (Dark)',
      brandBanner: 'Brand Banner',
      pageNumber: 'Page number',
      images: 'Images',
      channel: 'Channel',
      medium: 'Brand'
    },
    messages: errorMessages.en,
  },
  tr: {
    names: {
      contentType: 'İçerik Tipi',
      category: 'Kategori',
      source: 'Kaynak',
      author: 'Yazar',
      cartoonists: 'Çizerler',
      program: 'Program',
      magazineQuote: 'Kaynak Dergi Sayısı',
      signature: 'İmza',
      socialMedia: 'Sosyal Medya',
      title: 'Başlık',
      spot: 'Spot',
      tag: 'Etiket',
      photoGallery: 'Foto Galeri',
      infographicGallery: 'İnfografik Galeri',
      coverImage: 'Kapak Görseli',
      coverImageDescription: 'Kapak Görseli Açıklaması',
      coverVideo: 'Kapak Video',
      startDate: 'Başlangıç Tarihi',
      endDate: 'Bitiş Tarihi',
      publishDate: 'Yayın Tarihi',
      expirationDate: 'Geçerlilik Tarihi',
      headlineTag: 'Manşet Etiketi',
      platform: 'Platform',
      headlineOrder: 'Manşet sırası',
      order: 'Sıra',
      site: 'Site',
      role: 'Rol',
      permission: 'Yetki',
      externalLink: 'Dış Link',
      embedCode: 'Embed Kodu',
      mobileApplication: 'Mobil Uygulama',
      rows: 'Satır',
      columns: 'Sütun',
      subject: 'Konu Başlığı',
      book: 'Kitap',
      mainSubject: 'Ana Konu Başlığı',
      menuItemType: 'Öge Tipi',
      brandLogo: 'Marka Logosu',
      brandLogoDark: 'Marka Logosu (Koyu)',
      brandBanner: 'Marka Banner',
      pageNumber: 'Sayfa numarası',
      images: 'Resimler',
      channel: 'Kanal',
      medium: 'Marka'
    },
    messages: errorMessages.tr,
  },
});
